var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isHidden)?_c('section',{class:{
        'section': true,
        'section--last': _vm.isLastVisibleSection,
    }},[_vm._t("default"),(_vm.sectionEndButtonInDom)?_c('section-end-button',{attrs:{"label":_vm.sectionEndButtonLabel,"is-disabled":_vm.sectionEndButtonIsDisabled,"next-section":_vm.nextSection,"is-shown":_vm.sectionEndButtonIsShown},on:{"click":_vm.onSectionEndButtonClick}}):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }